import React from 'react';
import { useRouter } from '@edreamsodigeo/frontend-core';
import {
  useItinerarySelector,
  useSearchCriteriaSelector,
} from '@/providers/PriceFreezeOfferProvider';
import { selectItineraryInfo, selectTotalPax } from '@/selectors';
import { AppHeaderMobile } from './AppHeaderMobile';
import { ItineraryHeader } from './ItineraryHeader';
import { ACTIONS, usePFTracking } from '@/hooks/tracking';
import { useIsWebView } from '@/hooks/useIsWebView';

export function AppHeaderContainerMobile({ customCategory, customPageName }) {
  const router = useRouter();
  const isWebView = useIsWebView();
  const itineraryInfo = useItinerarySelector(selectItineraryInfo);
  const totalPax = useSearchCriteriaSelector(selectTotalPax);
  const { track } = usePFTracking();
  const onBack = () => {
    track(ACTIONS.HEADER.BACK, customCategory, customPageName);
    router.back();
  };

  if (isWebView) {
    return (
      <ItineraryHeader
        numberOfPax={totalPax}
        departure={itineraryInfo.departure}
        destination={itineraryInfo.destination}
        departureDate={itineraryInfo.departureDate}
        arrivalDate={itineraryInfo.arrivalDate}
      />
    );
  }

  return (
    <AppHeaderMobile
      onBack={onBack}
      numberOfPax={totalPax}
      departure={itineraryInfo.departure}
      destination={itineraryInfo.destination}
      departureDate={itineraryInfo.departureDate}
      arrivalDate={itineraryInfo.arrivalDate}
    />
  );
}
